import { render, staticRenderFns } from "./ModalEnabledDocument.vue?vue&type=template&id=0fa6c5e2"
import script from "./ModalEnabledDocument.vue?vue&type=script&lang=js"
export * from "./ModalEnabledDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports